
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap/lib'
import Api from './../../Global/Modules/Api';

class Announcement extends Component {
  constructor() {
    super();
    this.state = {
      News: []
    }
  }



  componentDidMount() {
    const FETCH_URL = 'api/news/3/news';
    Api.GetApi(FETCH_URL).then(data => {
      Api.print('News received')
      Api.print(data)
      let news = data.news.map(function (item, index) {
        return <div className="announcementItem" key={index}>
          <div className="announcementItemHeader">{item.title}</div>
          <div className="announcementDescription">{Api.formatDate(item.dateCreated)} </div>
          <div className="announcementDescription">{item.description} </div>
          <div className="announcementReadMore">
            {
              //eslint-disable-next-line
            } <Link to={"/nieuws/nieuws-item/" + item.id}>Lees meer</Link>
          </div>
        </div>
      })
      this.setState({ News: news });
    });
  }
  render() {

    return (
      <div className="announcements">
        <div className="announcementsHeader">Mededelingen</div>
        <div className="announcementsList">
          {this.state.News}
        </div>
        <div className="announcementsReadMore">
          {
            //eslint-disable-next-line
          } <Link to="/nieuws"><Glyphicon glyph="hand-right" /> Lees alle mededelingen</Link>
        </div>
      </div>
    );
  }
}

export default Announcement;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Announcement.js